// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3Z1Jq","header":"MessagesList_header__Z1D3G","chat":"MessagesList_chat__1k9fD"};